<template>
  <div>
    <b-table striped hover :items="items"></b-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      items: [
        { productor: "Dickerson", rnp: 3.5 },
        { productor: "Larsen", rnp: 3.2 },
        { productor: "Geneva", rnp: 3.0 },
        { productor: "Jami", rnp: 2.5 }
      ]
    };
  }
};
</script>
